<template>
  <a
    class="d-flex justify-content-center cursor-pointer"
    v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
    :title=file_name
    :href="url"
  >
    <font-awesome-icon icon="file-invoice" />
  </a>
</template>

<script>
export default {
  props: {
    file_name: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>
